module.exports = __webpack_public_path__ + "img/2.2a037e71.png";